module.exports = __webpack_public_path__ + "static/media/comment.c96c6a5d.svg";